import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { Skeleton, SKELETON_EXTENSION, type SkeletonProps } from '@chess/api-skeleton';

// The loading skeleton for any component. A component that can import
// `@chess/api-skeleton` uses `Skeleton` directly; a container may instead
// render this extension with the same props:
//   <app.Extension name="shared.skeleton" params={{ loading: !data, shape: <Card data={SAMPLE} />, children: data && <Card data={data} /> }} />
// See docs/architecture/core/plugin-shared-skeleton.md.
export function setup(app: PiletApi) {
  const SkeletonExtension: React.FC<{ params: SkeletonProps }> = ({ params }) => <Skeleton {...params} />;
  app.registerExtension<SkeletonProps>(SKELETON_EXTENSION, SkeletonExtension);
}
